import { useState } from 'react'
import { ChevronDownIcon } from '@radix-ui/react-icons'

interface CompanyPageAccordionProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  stickyHeader?: boolean
  stickyTopOffset?: number
  headerRight?: React.ReactNode
  collapsedContent?: React.ReactNode
  hideChevron?: boolean
  customTitle?: React.ReactNode
  noPaddingBottom?: boolean
  isMobile?: boolean
}

export function CompanyPageAccordion({
  title,
  children,
  defaultOpen = true,
  stickyHeader = false,
  stickyTopOffset = 0,
  headerRight,
  collapsedContent,
  hideChevron = false,
  customTitle,
  noPaddingBottom = false,
  isMobile = false,
}: CompanyPageAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="bg-gray-50 rounded-lg border border-gray-200 shadow-md isolate">
      {/* Accordion Header */}
      <div
        className={`${stickyHeader ? 'sticky bg-gray-50 z-40 rounded-t-lg' : 'relative'} ${isMobile ? 'p-3' : 'p-4'}`}
        style={
          stickyHeader
            ? {
                top: stickyTopOffset
                  ? `${stickyTopOffset}px`
                  : 'var(--company-top-card-height, 0px)',
              }
            : undefined
        }
      >
        <div className="flex items-center justify-between w-full gap-4">
          {hideChevron ? (
            <div className="flex items-center gap-2">
              {customTitle || (
                <span className="text-sm font-light tracking-widest text-gray-900 uppercase">
                  {title}
                </span>
              )}
            </div>
          ) : (
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="flex items-center gap-2 text-left focus:outline-none"
            >
              <ChevronDownIcon
                className={`w-5 h-5 text-green-700 transition-transform duration-200 ${
                  isOpen ? 'rotate-180' : ''
                }`}
              />
              {customTitle || (
                <span className="text-sm font-light tracking-widest text-gray-900 uppercase">
                  {title}
                </span>
              )}
            </button>
          )}
          {headerRight && (
            <div className="flex items-center gap-2">{headerRight}</div>
          )}
        </div>
      </div>

      {/* Accordion Content */}
      {hideChevron || isOpen ? (
        <div
          className={`${isMobile ? 'px-2' : 'px-4'} ${noPaddingBottom ? '' : 'pb-4'}`}
        >
          {children}
        </div>
      ) : (
        collapsedContent && <div className="px-2 pb-4">{collapsedContent}</div>
      )}
    </div>
  )
}
